module.exports = __webpack_public_path__ + "img/6.1538d5fe.png";